import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

// Type definitions
interface ProgramItem {
  id: string;
  name?: string;
  label?: string;
  [key: string]: unknown;
}

export interface ProgramState {
  programsList: ProgramItem[];
  availableProgramsList: ProgramItem[];
}

const initialState: ProgramState = {
  programsList: [],
  availableProgramsList: [],
};

const programSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    setProgramsList: (state, action) => {
      state.programsList = action.payload;
    },
    setAvailableProgramsList: (state, action) => {
      state.availableProgramsList = action.payload;
    },
  },
});

export const { setProgramsList, setAvailableProgramsList } = programSlice.actions;

// <-- selector to “get” -->
export const selectProgramsList = (state: RootState) =>
  state.program.programsList;
export const selectAvailablePrograms = (state: RootState) =>
  state.program.availableProgramsList;

export default programSlice.reducer;
